(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.custom-tabs').forEach(tabs => {
  const buttons = tabs.querySelectorAll('.tab-button');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.dataset.tab;

      tabs.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
      tabs.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

      button.classList.add('active');
      const content = tabs.querySelector(`.tab-content[data-tab="${tabId}"]`);
      if(content) content.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
